export default __webpack_public_path__ + "static/caster-d621e491b16a0e39a65b3a451e0d04f6.png";